import { render } from "./legoPage.vue?vue&type=template&id=799f54be"
import script from "./legoPage.vue?vue&type=script&lang=js"
export * from "./legoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/layout/legoPage/legoPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "799f54be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('799f54be', __exports__)) {
    api.reload('799f54be', __exports__)
  }
  
  module.hot.accept("./legoPage.vue?vue&type=template&id=799f54be", () => {
    api.rerender('799f54be', render)
  })

}


export default __exports__